module.exports = __webpack_public_path__ + "static/img/Freijah.12d8e9e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Freijah.jpg
// module id = iqs4
// module chunks = 0